import SearchBar from "../../components/org/SearchBar"
export default function OrgManager () {
    return <SearchBar/>
}